<div class="revision-notice-component">
    <div class="modal-title">You are about to create a revision!</div>
    <div class='modal-text'>
        Doing this will prevent any other revisions for this learning object from being created until this revision is released. Are you sure you want to do this?
    </div>
    <div class="btn-group center">
      <button class="button good" (activate)="createRevision.emit()">Confirm</button>
      <button class="button bad" (activate)="close.emit()">Cancel</button>
    </div>
</div>